import React from 'react'

import { Text } from 'Components/UI'
import { DateTime } from 'luxon'

import { Container } from './styles'

function FooterCopyrights() {
  return (
    <Container>
      <Text body14 invertedMuted semiLight>
        All rights reserved. © StartupCraft
      </Text>

      <Text body14 invertedMuted semiLight>
        {DateTime.local().toFormat('yyyy')}
      </Text>
    </Container>
  )
}

export default FooterCopyrights
